import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { HERO_IMAGE } from '../../data/content';
const badges = ['Accesso Digitale Immediato', 'Pagamento Una Tantum', 'Accesso a Vita', 'Garanzia 7 Giorni'];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream" data-id="element-188" data-mp="huny9tj13ym8">
      <div className="pointer-events-none absolute -top-40 left-1/2 h-[420px] w-[420px] -translate-x-1/2 rounded-full bg-plum-soft opacity-70 blur-[90px]" aria-hidden="true" data-id="element-189" data-mp="hsutkjrz7ogv" />
      <div className="relative mx-auto w-full max-w-content px-5 pb-12 pt-8 sm:px-8 sm:pt-12 lg:pb-20" data-id="element-190" data-mp="qtj5n8xt7er4">
        <p className="text-center font-display text-lg font-black tracking-tight text-plum-deep sm:text-xl" data-id="element-191" data-mp="voor66naureo">
          Dr. Karito
        </p>

        <p className="mx-auto mt-5 w-fit rounded-full bg-plum/10 px-3.5 py-1.5 text-center text-[10.5px] font-extrabold uppercase tracking-[0.16em] text-plum sm:text-xs" data-id="element-192" data-mp="15lbcewjjfkh8">
          Progetto Clinico della Menopausa™
        </p>

        <h1 className="mx-auto mt-5 max-w-3xl text-balance text-center font-display text-[34px] font-black leading-[1.05] tracking-[-0.02em] text-plum-deep sm:text-5xl lg:text-6xl" data-id="element-193" data-mp="9pdtbkaczwdn">
          Valuta, prescrivi e gestisci la Terapia Ormonale in meno di{' '}
          <span className="text-teal" data-id="element-194" data-mp="3rtxkdzdsq45b">5 minuti</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-[15.5px] leading-relaxed text-ink/70 sm:text-lg" data-id="element-195" data-mp="3rvs79j8mo6c1">
          Un sistema clinico passo dopo passo, basato sulle evidenze. Smetti di mettere
          continuamente in dubbio le tue decisioni terapeutiche o di perdere tempo prezioso
          cercando informazioni in numerose linee guida.
        </p>

        <p className="mx-auto mt-4 max-w-xl text-center text-[14px] font-semibold text-plum sm:text-[15px]" data-id="element-196" data-mp="em48m5ecany0">
          Scelto da oltre 2.000 medici che desiderano esercitare con maggiore sicurezza, coerenza e
          chiarezza clinica.
        </p>

        <div className="mx-auto mt-8 w-full max-w-2xl" data-id="element-197" data-mp="30lxdm9z3wawp">
          <img src={HERO_IMAGE} alt="Sistema completo del Progetto Clinico della Menopausa in 6 volumi con risorse digitali" className="w-full" width={1080} height={1080} data-id="element-198" data-mp="30mfl62r7ybjx" />
        </div>

        <div className="mx-auto mt-4 max-w-xl" data-id="element-199" data-mp="2vup4lf1ourk2">
          <CTAButton label="Ottieni l’accesso immediato al progetto completo" variant="teal" data-id="element-200" data-mp="2vte1zijzbpuj" />
        </div>

        <ul className="mx-auto mt-6 flex max-w-2xl flex-wrap items-center justify-center gap-x-4 gap-y-2.5" data-id="element-201" data-mp="2mu95sivw48lj">
          {badges.map(badge => <li key={badge} className="inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-ink/65 sm:text-sm" data-id="element-202" data-mp="27yt4ptww7cfn">
              <CheckIcon className="h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-203" data-mp="65n58nxl6ary" />
              {badge}
            </li>)}
        </ul>

        <div id="hero-cta-end" aria-hidden="true" className="h-px w-full" data-id="element-204" data-mp="b2vpqv67iqwd" />
      </div>
    </header>;
}